import { ref, onBeforeUnmount, getCurrentInstance } from 'vue';

export const MOBILE_BREAKPOINT = 768;

const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

/**
 * Plain function for non-reactive mobile checks (e.g. chart utility functions).
 */
export const isMobileViewport = () => window.innerWidth <= MOBILE_BREAKPOINT;

/**
 * Vue composable returning a reactive ref that tracks the mobile breakpoint.
 * Uses matchMedia so it only fires when the threshold is crossed.
 */
export const useIsMobile = () => {
  const isMobile = ref(mediaQuery.matches);

  const handler = e => {
    isMobile.value = e.matches;
  };

  mediaQuery.addEventListener('change', handler);

  if (getCurrentInstance()) {
    onBeforeUnmount(() => {
      mediaQuery.removeEventListener('change', handler);
    });
  }

  return isMobile;
};
